// src/components/ConfirmDeleteModal.js
import React, { useState } from 'react';
import { deleteTransaction } from '../services/api';

const ConfirmDeleteModal = ({ transaction, onClose }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleDelete = async () => {
        setLoading(true);
        setError('');

        try {
            await deleteTransaction(transaction.id);
            onClose();
        } catch (err) {
            setError('Erro ao apagar transação. Tente novamente.');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2 style={{ marginBottom: '20px' }}>Confirmar Exclusão</h2>

                {error && <p style={{ color: 'red', marginBottom: '15px' }}>{error}</p>}

                <p style={{ marginBottom: '20px' }}>
                    Tem certeza que deseja apagar a transação <strong>{transaction.descricao}</strong> no valor de{' '}
                    {new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    }).format(transaction.valor)}?
                </p>

                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                    <button
                        type="button"
                        className="btn btn-danger"
                        onClick={onClose}
                        disabled={loading}
                    >
                        Cancelar
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleDelete}
                        disabled={loading}
                    >
                        {loading ? 'Apagando...' : 'Apagar'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmDeleteModal;